export const userDiscountCodes = {
  name: "userDiscountCodes",
};
